var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (config, i18n, slides, title) {
buf.push("<div id=\"lesson-menu\"><div id=\"lesson-menu-content\" class=\"content-ver block-h-xl text-center\"><h1 class=\"tight delay-1\">" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)) + "</h1><h3 id=\"lesson-menu-page-count\"" + (jade.attr("data-total", slides.length, true, false)) + " class=\"block-v-md delay-2\">&nbsp;</h3><hr/><div class=\"block-v-lg clearfix\"><div id=\"lesson-menu-cancel\" class=\"btn btn-block btn-sm btn-primary\">" + (jade.escape(null == (jade_interp = i18n("menu.resume")) ? "" : jade_interp)) + "</div>");
if ( config.contextAllowsFreeNavigation || config.contextRequiresExitButton)
{
if ( config.contextAllowsFreeNavigation)
{
buf.push("<div id=\"lesson-menu-go-back\" class=\"btn btn-block btn-muted\">" + (jade.escape(null == (jade_interp = i18n("menu.go-back")) ? "" : jade_interp)) + "</div><div id=\"lesson-menu-restart\" class=\"btn btn-block btn-muted\">" + (jade.escape(null == (jade_interp = i18n("menu.restart")) ? "" : jade_interp)) + "</div>");
}
if ( config.contextRequiresExitButton && !config.isQuiz)
{
buf.push("<div id=\"lesson-menu-exit\" class=\"btn btn-block btn-muted\">" + (jade.escape(null == (jade_interp = i18n("menu.exit")) ? "" : jade_interp)) + "</div>");
}
else if ( config.contextRequiresExitButton && config.isQuiz)
{
buf.push("<div id=\"lesson-menu-exit\" class=\"btn btn-block btn-outlined\">" + (jade.escape(null == (jade_interp = i18n("menu.exit-quiz")) ? "" : jade_interp)) + "</div>");
}
}
else
{
buf.push("<div id=\"lesson-menu-cancel\" class=\"btn btn-block btn-muted\">" + (jade.escape(null == (jade_interp = i18n("buttons.continue")) ? "" : jade_interp)) + "</div>");
}
buf.push("</div></div></div>");}.call(this,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"slides" in locals_for_with?locals_for_with.slides:typeof slides!=="undefined"?slides:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}